export default __webpack_public_path__ + "static/media/key-vertical-ghost.ed68463c.svg";